
<app-header *ngIf="showHeader"></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>

<app-modal-contact *ngIf="modalOpen" (close)="closeModal($event)" [modalData]="modalData" ></app-modal-contact>